import React from 'react'
import { AiFillLinkedin , AiFillGithub } from 'react-icons/ai'
import back from '../assests/back.jpg'
export default function Contact() {
  return (
        <div className='mt-[200px]' id="Contact">
            <div className='flex justify-center items-center'>
                <p className='text-border text-[#C0392B] text-lg md:text-5xl uppercase border-2 border-[#C0392B] rounded-lg shadow-[#C0392B] shadow-lg p-2'>Contact Us</p>
            </div>
            <div className='px-6 max-w-[1000px] mx-auto glass grid md:grid-cols-2 place-items-center mt-[20px]' >
                    <div>
                        <img src={back} alt="Image" className='w-[500px]'/>
                    </div>
                    <form action="https://getform.io/f/nbdoepda" method="POST" className='max-w-6xl p-5 md:p-12 ' id="form">
                        <input
                            type='text'
                            placeholder='Your Name ...'
                            id='name'
                            name='name'
                            className='mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 '
                        />
                        <input
                            type='email'
                            placeholder='Your Email ...'
                            id='email'
                            name='email'
                            className='mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 '
                        />                
                        <textarea
                            placeholder='Your Massege ...'
                            id='textarea'
                            cols="30"
                            rows="4"
                            name='textarea'
                            className='mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 '
                        />
                        <button type='submit' className='w-full py-3 rounded-md text-gray-200 font-semibold text-xl 
                        bg-gradient-to-r from-[#C0392B] via-[#C0392B] '>Send Message</button>
                    </form>
            </div>
        </div>
  )
}

